import { Box } from '@material-ui/core';
import { Billing, Shipping } from '@nemuru-eng/js-api-client';

import { BillingDetails } from '@/components/modules/ShippingAndBilling/_shared/components/BillingDetails/BillingDetails';
import { ShippingDetails } from '@/components/modules/ShippingAndBilling/_shared/components/ShippingDetails/ShippingDetails';

interface ShippingAndBillingProps {
  shipping: Shipping | null;
  billing: Billing | null;
}

export const ShippingAndBilling = ({ shipping, billing }: ShippingAndBillingProps) => {
  return (
    <>
      <ShippingDetails shipping={shipping} />
      <Box mt={3} />
      <BillingDetails billing={billing} />
    </>
  );
};
